import axiosInstance, { AxiosRequestConfig } from "axios";
import MockAdapter from "axios-mock-adapter";

const { config } = require("./config") as { config: { api: { BASE_URL: string } } };

// if (process.env.NODE_ENV == "test") {
//     axiosInstance.interceptors.request.use(request => {
//         console.log('Starting Request', request)
//         return request
//     })
// }

const mockAxios = {
    get: function() {
        return Promise.resolve({ data: {
            subject: {
                user: "subject_user",
                slug: "subject_slug",
                users: []
            }
        }
    })
    },
    post: function() {
        return Promise.resolve({ data: {} })
    }
};

export function mock() {
    return new MockAdapter(axiosInstance);
}

export function createModquizClient(options: AxiosRequestConfig) {
    return axiosInstance.create(options);
}

export function axios() {
    const user: any = localStorage.getItem("user");

    var headers = {};

    if (user) {
        headers = { Authorization: "Bearer " + user };
    }

    // Mock Axios object if testing;
    if (process.env.NODE_ENV == "test") {
        return axiosInstance
    }

    console.log(`Axios configured with BASE_URL: ${config.api.BASE_URL}`);
    console.log(`Axios configured with browserBaseURL: ${config.api.BASE_URL}`);

    return createModquizClient({
        baseURL: config.api.BASE_URL,
        headers: headers
    });
}
